import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MiniPrompt from './MiniPrompt'
import CloseIcon from './CloseIcon'
import ChatIcon from './ChatIcon'
import Badge from '@material-ui/core/Badge'
import PoweredBy from '../src/PoweredBy'
import { SessionContext } from './session-context'

const useStyles = makeStyles(() => ({
  badge: {
    color: 'white',
    backgroundColor: 'red'
  }
}))

function ChatPrompt (props) {
  const { welcomePacket } = useContext(SessionContext)
  const toggleOpenChat = props.toggleOpenChat
  const classes = useStyles()
  const setDisplayState = props.setDisplayState

  if (props.hidden) {
    return <></>
  } else if (props.phone && props.openChat && !props.bigPrompt) {
    return <></>
  }

  if (props.openChat) {
    return (
      <div className='chat-prompt'>
        <div className='inner-chat-prompt'>
          <div id='chat-icon' onClick={toggleOpenChat}>
            <CloseIcon />
          </div>
          {welcomePacket.branding
            ? <PoweredBy />
            : <></>}
        </div>
      </div>
    )
  }

  return (
    <div className='chat-prompt'>
      <div className='inner-chat-prompt'>
        <div id='chat-icon' onClick={toggleOpenChat}>
          <ChatIcon
            contrastColor={welcomePacket.contrast_color}
            iconID={welcomePacket.prompt_icon_id}
            promptIconUrl={welcomePacket.prompt_icon_url}
          />
        </div>
        {props.showMiniPrompt
          ? (
            <MiniPrompt
              openChat={props.openChat}
              toggleOpenChat={toggleOpenChat}
              packet_code={props.packet_code}
              events={props.events}
              setDisplayState={setDisplayState}
            />
          ) : <></>}
      </div>
    </div>
  )
}

export default ChatPrompt
